import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Router } from '@angular/router';
import { Azienda } from '../../models/azienda';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { configurazione } from '../../../configurazioni/configurazione';
import { Comune } from '../../models/comune';
import { Sede } from '../../models/sede';
import { of, Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmComponent } from '../../dialog/confirm/confirm.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-addazienda',
  templateUrl: './addazienda.component.html',
  styleUrls: ['./addazienda.component.css']
})
export class AddaziendaComponent implements OnInit {
  azienda: Azienda=new Azienda();
  hide = true;
  rc:number;
  aziendatoedit: boolean;
  
//  IPAddress:string;
//  Port:string;
//  Protocol:string;
  registerForm: FormGroup;

  submitted = false;
  comuni: Comune[]=[];
  comunifiltrati: Observable<Comune[]>;
  nomeComune:string="";
  nomesede:string="";
  indirizzo:string="";
  cap:string="";
  public message =  sessionStorage.getItem('token');
  sede:Sede=null;
  displayedColumns: string[] = [
  "Nome",
  "Indirizzo",
  "Cap",
  "Nomecomune",
  "elimina"
  ];
  sedi:Sede[]=[];
  dataSource = new MatTableDataSource<Sede>(this.sedi);
  labelAzienda: string="Dettaglio Azienda";

  constructor(private httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder,  private dialog: MatDialog) {
  /*    if (environment.address.isLocal){
        this.IPAddress=environment.address.localIP;
        this.Port=environment.address.localPort;
        this.Protocol=environment.address.localProtocol;
      }else{
        this.IPAddress=environment.address.remoteIP;
        this.Port=environment.address.remotePort;
        this.Protocol=environment.address.remoteProtocol;
      }
*/
    }

  ngOnInit(): void {

    if (this.commonService.currentIstanza.Codice==6){ 
        this.labelAzienda="Dettaglio Cliente";
      }else if (this.commonService.currentIstanza.Codice==8){
        this.labelAzienda="Dettaglio Fornitore";
    }

    this.commonService.getAllComuni().subscribe(data => {
          this.comuni=data;
          this.comunifiltrati = of(this.comuni);
    });

    if (this.registerForm===undefined){
      this.registerForm = this.formBuilder.group({
            Nome: ['', Validators.required],
            Partitaiva: [''],// [Validators.required, Validators.pattern('^[a-z0-9]')]],
            Missione: [''],
            Codicefiscale: [''],//['', [Validators.minLength(16), Validators.maxLength(16)]],
            Email: ['', [Validators.email,Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
            Pec: ['', [Validators.email,Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
            Telefono: [''],
            Cellulare: [''],
            Sdi: [''],
            Ragionesociale: [''],
            Attivita: [''],
            Numerodipendenti: ['0'], //, [Validators.pattern(/^\d+'/)]],
            Rea: [''],
            Datarea: [''], //,[Validators.pattern(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/)]],
            Cameracommercio: ['0'],
            Codice: ['0'],
            Nomesede: [''],
            Indirizzo: [''],
            Cap: [''],
            Tiporelazione: ['']
        });
    }



        if (this.commonService.selectedAzienda!=undefined){
          this.azienda=this.commonService.selectedAzienda;
          this.aggiornaListaSedi();
          
          this.commonService.selectedAzienda=undefined;

          this.registerForm.setValue({
            Nome: this.azienda.Nome,
            Partitaiva: this.azienda.Partitaiva,
            Missione: this.azienda.Missione,
            Codicefiscale: this.azienda.Codicefiscale,
            Email: this.azienda.Email,
            Pec: this.azienda.Pec,
            Telefono: this.azienda.Telefono,
            Cellulare: this.azienda.Cellulare,
            Sdi: this.azienda.Sdi,
            Ragionesociale: this.azienda.Ragionesociale,
            Attivita: this.azienda.Attivita,
            Numerodipendenti: this.azienda.Numerodipendenti,
            Rea: this.azienda.Rea,
            Datarea: this.azienda.Datarea,
            Cameracommercio: this.azienda.Cameracommercio,
            Codice: this.azienda.Codice,
            Nomesede: this.nomesede,
            Indirizzo: this.indirizzo,
            Cap: this.cap,
            Tiporelazione: this.azienda.Tiporelazione
          });
        }else{
          this.azienda=new Azienda();
        }
    }

get f() { return this.registerForm.controls; }

aggiornaListaSedi(){
    this.commonService.getAllSediByAziendaid(this.azienda.Codice)
      .subscribe(response => {
        let tempsedi:Sede[]=response;
        this.refreshListaSedi(tempsedi);
      });
   }
refreshListaSedi(listasedi:Sede[]){
     this.sedi=listasedi;
     this.dataSource = new MatTableDataSource<Sede>(this.sedi);
}
 
save() {
/*
        if (this.registerForm.value['Indirizzo']!=undefined && this.registerForm.value['Indirizzo']!='' && this.registerForm.value['Cap']!=undefined && this.registerForm.value['Cap']!=''){
          let sedeprincipale=new Sede();
          sedeprincipale.Indirizzo=this.registerForm.value['Indirizzo'];
          sedeprincipale.Cap=this.registerForm.value['Cap'];
          sedeprincipale.Nomecomune=this.nomeComune;
          sedeprincipale.Codiceazienda=this.azienda.Codice;
          this.azienda.Sedelist.push(sedeprincipale);
        }else if((this.registerForm.value['Indirizzo']==undefined || this.registerForm.value['Indirizzo']=='') && (this.registerForm.value['Cap']==undefined || this.registerForm.value['Cap']=='')){
          // Entrambi vuoti, niente da fare
        }else{ 
          alert("Attenzione: se si inserisce un indirizzo è necessario inserire anche il cap e viceversa");
          return;
        } 
*/
        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else{ 
            if (this.commonService.currentIstanza.Codice==6){ 
                this.registerForm.patchValue({ Tiporelazione: 2 });
              }else if (this.commonService.currentIstanza.Codice==8){
                this.registerForm.patchValue({ Tiporelazione: 1 });
            }
            
            this.commonService.saveAzienda(this.registerForm.value).subscribe(data => {
              this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
              //console.log("--->SaveUser"+this.rc.toString());
              if (this.rc===0){
                alert("Azienda già esistente");
              }else if (this.rc===-1){
                alert("Errore creazione azienda");
              }else if (this.rc===-2){
                alert("Errore nome azienda esistente");
              }else{
                alert("Azienda salvata con successo");
                this.router.navigate(['aziende']);
              }
            });

        }
    //    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value))
    }
  saveSede() {
        this.sede=new Sede();
        if (this.registerForm.value['Indirizzo']!=undefined && this.registerForm.value['Indirizzo']!='' && this.registerForm.value['Cap']!=undefined && this.registerForm.value['Cap']!=''){
        
          this.sede.Nome=this.registerForm.value['Nomesede'];
          this.sede.Indirizzo=this.registerForm.value['Indirizzo'];
          this.sede.Cap=this.registerForm.value['Cap'];
          this.sede.Nomecomune=this.nomeComune;
          this.sede.Codiceazienda=this.azienda.Codice;
        }else if((this.registerForm.value['Indirizzo']==undefined || this.registerForm.value['Indirizzo']=='') && (this.registerForm.value['Cap']==undefined || this.registerForm.value['Cap']=='')){
          // Entrambi vuoti, niente da fare
        }else{ 
          alert("Attenzione: se si inserisce un indirizzo è necessario inserire anche il cap e viceversa");
          return;
        }  
          this.commonService.saveSede(this.sede).subscribe(data => {
            this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
            //console.log("--->SaveUser"+this.rc.toString());
            if (this.rc>0){
              alert("Sede salvata con successo");
              this.aggiornaListaSedi();
            }else if (this.rc===-1){
              alert("Errore creazione sede");
            }else if (this.rc===-2){
              alert("Errore nome sede esistente per questa azienda");
            }
          });
    } 
    
  eliminaSede(sede: Sede){
    const dialogRef = this.dialog.open(ConfirmComponent, {
        width: '250px',
        data: {title:'Attenzione',description:'Confermi la cancellazione?'}
    });  
    dialogRef.afterClosed().subscribe(result => {
        if (result){
          const data = new FormData();
          data.append('codice', sede.Codice.toString());
          this.commonService.deleteSede(sede).subscribe((response) => {
              this.aggiornaListaSedi();
          });
      }
    });
  } 

  gotosedi(){
    this.commonService.selectedAzienda=this.azienda;
    this.router.navigate(['sedi']);
  }
  cancel(){
    this.commonService.selectedAzienda=null;
    this.router.navigate(['aziende']);
  }

    onFiltroCapKeyup(event:any){
          if (event.target.value!=undefined){
            this.comunifiltrati = of(this.comuni.filter(a=> a.Cap.indexOf(event.target.value)>-1));
          }
    }
  onCapSelected(event: MatAutocompleteSelectedEvent) {
    // Logica da eseguire quando viene selezionato un CAP
    //console.log('CAP selezionato:', event.option.value);
    let comuneSelezionato=this.comuni.filter(a=> a.Cap==event.option.value)[0];
    this.nomeComune=comuneSelezionato.Nome;
  }
  myFilter(d: Date): boolean {
    if(d!=undefined){
      const selectinablemonth = d.getMonth();
      const selectinableyear = d.getFullYear();
      const selectinableday = d.getDate();
      const todaysDateObject = new Date();
      const actualday = todaysDateObject.getDate();
      const actualmonth = todaysDateObject.getMonth();
      const actualyear = todaysDateObject.getFullYear();
      return true;
//      if (actualyear - 11> selectinableyear){
//        return true;
//      }else{
//        return false;
//      }
    }
    return false;
  }

  getConfigurazione(){
    if (this.commonService.currentIstanza!=undefined){
      if (this.commonService.currentIstanza.Codice === 1){
        return configurazione.addazienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 2){
        return configurazione.addazienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 3){
        return configurazione.addazienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 4){
        return configurazione.addazienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 5){
        return configurazione.addazienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 6){
        return configurazione.addazienda.orfri;
      }else if (this.commonService.currentIstanza.Codice === 7){
        return configurazione.addazienda.fb;
      }
    }
    return configurazione.addazienda.fb;
  }

}
